import Divider from '@com/_atoms/Divider';
import { Button } from '@com/_atoms/NewButton';
import { colorPallete } from '@configs/color-pallete';

import Icon from '@utilities/icon';

type DoctorOfficeProps = {
  officeName: string;
  doctorName: string;
  address: string;
  isActive: boolean;
  onBookClick: () => void;
};

const DoctorOffice = ({
  officeName,
  doctorName,
  address,
  isActive,
  onBookClick,
}: DoctorOfficeProps) => {
  return (
    <div className="flex flex-col gap-y-2 rounded-lg p-4 shadow-fab">
      <div className="flex items-center gap-x-2">
        <div className="h-8 w-8 rounded-lg flex items-center justify-center bg-surface-accentLight">
          <Icon
            name="HomeHealth"
            width={1.5}
            height={1.5}
            fill={colorPallete.content.accent}
          />
        </div>
        <span className="text-Label/Small text-content-secondary flex items-center gap-x-1">
          {officeName}
          <span className="text-content-tertiary">{`(${doctorName})`}</span>
        </span>
      </div>

      <Divider padding={0} className="h-[1px] bg-border-primary" />

      <ul className="list-disc px-4">
        <li className="text-content-tertiary text-Label/xSmall">
          <span className="text-Label/Small text-content-primary">
            آدرس مطب:
          </span>{' '}
          {address}
        </li>
      </ul>

      <Button
        variant="brand"
        onClick={onBookClick}
        size="small"
        icon={
          <Icon
            name="ChevronLeft"
            width={1}
            height={1}
            className="min-w-4"
            fill={colorPallete?.content?.onInverse}
          />
        }
        iconPosition="left"
        disabled={!isActive}
      >
        <span className="line-clamp-1">{`رزرو نوبت از مطب ${officeName}`}</span>
      </Button>
    </div>
  );
};

export default DoctorOffice;
